import { Image } from "antd";

export const ImagePreview = ({ imageUrls }: { imageUrls: string[] }) => {
  return (
    <Image.PreviewGroup>
      {imageUrls.map((url, index) => (
        <Image width={50} height={50} loading="lazy" src={url} key={index} />
      ))}
    </Image.PreviewGroup>
  );
};
